import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { BentoBoxEntry } from "frontend/contentful/schema/semantics";
import { BentoBoxProps } from "design-system/sites/baker/bento-box/bento-box";
import { createBentoBoxColumnProps } from "../primitives/bento-box-column.props";
import { useContentful } from "frontend/hooks/use-contentful";

export interface BentoBoxOptions {
  tabTitle?: string;
  headerAbove?: boolean;
}

export const createBentoBoxProps = createContentfulProps<
  BentoBoxEntry,
  BentoBoxProps,
  BentoBoxOptions
>(({ entry, options }) => {
  const { getEntries } = useContentful();
  const columns: BentoBoxProps["bentoBoxColumns"] = [];
  const tabTitle = options?.tabTitle;
  const headerAbove = options?.headerAbove;

  getEntries(entry.fields.columns)?.forEach((column) => {
    const props = createBentoBoxColumnProps(column, {
      tabTitle: tabTitle,
      headerAbove: headerAbove,
    });
    if (props) {
      columns.push(props);
    }
  });

  return {
    bentoBoxColumns: columns,
  } satisfies BentoBoxProps;
});
